import type { Metric } from '@atlassian/browser-metrics/metric';

import { createInteractionMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { MORE_ACTIONS_DROPDOWN_INTERACTION } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const MORE_ACTIONS_DROPDOWN_METRIC: Metric = createInteractionMetric({
	key: MORE_ACTIONS_DROPDOWN_INTERACTION,
});
